// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YuJHW8BlmwtJgSoqdzPK {
  background-color: var(--primary-color);
  padding: var(--space-xl) 0 var(--space-2xl);
}

.XsfoldLs90BSfVoYhFog {
  font-family: var(--main-font);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  color: var(--white-color);
}

.D7MzyQmreAtb14S94CGt {
  max-width: var(--grid-max-width);
  padding-inline: var(--grid-gutter);
  margin-inline: auto;
}

.WESBwnFY8dWTk3MJVFzQ img {
  display: block;
  width: 100%;
  height: 94%;
  object-fit: fill;
  object-position: left center;
  transition: var(--global-nav-transition);
  border-style: none;
  max-width: 100%;
}

.GMogYbO94UgYkFln3TFA {
  color: var(--accent-color);
  font-size: var(--step-0);
  font-weight: 700;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  transition: var(--global-nav-transition);
}

.GMogYbO94UgYkFln3TFA:hover {
  color: var(--white-color);
}

.RzNLjSuVdYnO6n4NIsQY {
  display: flex;
  justify-content: space-between;
  gap: var(--space-m);
  margin-top: var(--space-m);
  margin-left: calc(var(--space-xl) + var(--space-xs));
}

.RzNLjSuVdYnO6n4NIsQY a {
  align-items: center;
  display: flex;
  color: var(--accent-color);
  font-size: var(--step-0);
  font-weight: 700;
  text-decoration: none;
  padding: 0;
  transition: var(--global-nav-transition);
}

.RzNLjSuVdYnO6n4NIsQY a:hover {
  color: var(--white-color);
}

.hBKTwO9bnLdnGgQmC2UP {
  flex: 1 1 100%;
  margin-top: var(--space-s);
  margin-left: calc(var(--space-xl) + var(--space-xs));
}

.hBKTwO9bnLdnGgQmC2UP a {
  display: inline-block;
  font-size: var(--step--1);
  font-weight: 500;
  color: var(--white-color);
  margin-top: var(--space-3xs);
  text-decoration: none;
  transition: var(--global-nav-transition);
}

.hBKTwO9bnLdnGgQmC2UP a:hover {
  text-underline-position: under;
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/layout/GlobalFooterContent.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B","sourcesContent":[".globalFooter {\n  background-color: var(--primary-color);\n  padding: var(--space-xl) 0 var(--space-2xl);\n}\n\n.globalFooterContent {\n  font-family: var(--main-font);\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  color: var(--white-color);\n}\n\n.uContainer {\n  max-width: var(--grid-max-width);\n  padding-inline: var(--grid-gutter);\n  margin-inline: auto;\n}\n\n.footerLogo img {\n  display: block;\n  width: 100%;\n  height: 94%;\n  object-fit: fill;\n  object-position: left center;\n  transition: var(--global-nav-transition);\n  border-style: none;\n  max-width: 100%;\n}\n\n.contactButton {\n  color: var(--accent-color);\n  font-size: var(--step-0);\n  font-weight: 700;\n  text-decoration: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: var(--global-nav-transition);\n}\n\n.contactButton:hover {\n  color: var(--white-color);\n}\n\n.navFooter {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-m);\n  margin-top: var(--space-m);\n  margin-left: calc(var(--space-xl) + var(--space-xs));\n}\n\n.navFooter a {\n  align-items: center;\n  display: flex;\n  color: var(--accent-color);\n  font-size: var(--step-0);\n  font-weight: 700;\n  text-decoration: none;\n  padding: 0;\n  transition: var(--global-nav-transition);\n}\n\n.navFooter a:hover {\n  color: var(--white-color);\n}\n\n.copyright {\n  flex: 1 1 100%;\n  margin-top: var(--space-s);\n  margin-left: calc(var(--space-xl) + var(--space-xs));\n}\n\n.copyright a {\n  display: inline-block;\n  font-size: var(--step--1);\n  font-weight: 500;\n  color: var(--white-color);\n  margin-top: var(--space-3xs);\n  text-decoration: none;\n  transition: var(--global-nav-transition);\n}\n\n.copyright a:hover {\n  text-underline-position: under;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"globalFooter": `YuJHW8BlmwtJgSoqdzPK`,
	"globalFooterContent": `XsfoldLs90BSfVoYhFog`,
	"uContainer": `D7MzyQmreAtb14S94CGt`,
	"footerLogo": `WESBwnFY8dWTk3MJVFzQ`,
	"contactButton": `GMogYbO94UgYkFln3TFA`,
	"navFooter": `RzNLjSuVdYnO6n4NIsQY`,
	"copyright": `hBKTwO9bnLdnGgQmC2UP`
};
export default ___CSS_LOADER_EXPORT___;
